import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import PageNotFound from "../components/PageNotFound";
import PublicRoute from "./PublicRoute";
import LoginPage from "../components/consumer/login/LoginPage";
import ResetPasswordPage from "../components/consumer/reset-password/ResetPasswordPage";
import SignUpPage from "../components/consumer/sign-up/SignUpPage";
import ConsumerRoute from "./ConsumerRoute";
import DashboardPage from "../components/consumer/dashboard/DashboardPage";
import OrganizationPage from "../components/consumer/organization/OrganizationPage";
import InvitesPage from "../components/consumer/invitations/InvitesPage";
import ApplicationsPage from "../components/consumer/applications/ApplicationsPage";
import NewApplicationPage from "../components/consumer/applications/NewApplicationPage";
import ApplicationPage from "../components/consumer/applications/ApplicationPage";
import SupportPage from "../components/consumer/support/SupportPage";
import UpgradePage from "../components/consumer/upgrade/UpgradePage";
import ProfilePage from "../components/consumer/profile/ProfilePage";
import ValidatePage from "../components/consumer/ValidatePage";
import NewOrganizationPage from "../components/consumer/organization/NewOrganizationPage";
import ForgotPasswordPage from "../components/consumer/forgot-password/ForgotPasswordPage";
import PropTypes from "prop-types";
import OrganizationUserEditPage from "../components/consumer/organization/OrganizationUserEditPage";
import ConfirmEmailPageLock from "../components/confirm-email/ConfirmEmailPageLock"

const ConsumerRoutes = ({ cableApp }) => {
  return (
    <Router>
      <Switch>
        <PublicRoute component={LoginPage} exact path="/login" />
        <PublicRoute
          component={ValidatePage}
          exact
          path="/account-activation"
        />
        <PublicRoute
          component={ValidatePage}
          exact
          path="/reset-password-validation"
        />
        <PublicRoute
          component={ForgotPasswordPage}
          exact
          path="/forgot-password"
        />
        <PublicRoute
          component={ResetPasswordPage}
          exact
          path="/reset-password"
        />
        <PublicRoute component={SignUpPage} exact path="/sign-up" />
        <ConsumerRoute
          condition={["Admin", "Developer"]}
          cableApp={cableApp}
          component={DashboardPage}
          exact
          path="/"
        />
        <ConsumerRoute
          condition={["Admin"]}
          cableApp={cableApp}
          component={OrganizationPage}
          exact
          path="/organization"
        />
        <ConsumerRoute
          condition={["Admin"]}
          cableApp={cableApp}
          component={OrganizationUserEditPage}
          exact
          path="/users/:id/edit"
        />
        <ConsumerRoute
          condition={["Admin"]}
          cableApp={cableApp}
          component={InvitesPage}
          exact
          path="/invites"
        />
        <ConsumerRoute
          condition={["Admin", "Developer"]}
          cableApp={cableApp}
          component={ApplicationsPage}
          exact
          path="/applications"
        />
        <ConsumerRoute
          condition={["Admin", "Developer"]}
          cableApp={cableApp}
          component={NewApplicationPage}
          exact
          path="/applications/new"
        />
        <ConsumerRoute
          condition={["Admin", "Developer"]}
          cableApp={cableApp}
          component={ApplicationPage}
          exact
          path="/applications/:id"
        />
        <ConsumerRoute
          condition={["Admin", "Developer"]}
          cableApp={cableApp}
          component={SupportPage}
          exact
          path="/support"
        />
        <ConsumerRoute
          condition={["Admin"]}
          cableApp={cableApp}
          component={UpgradePage}
          exact
          path="/upgrade"
        />
        <ConsumerRoute
          condition={["Admin", "Developer"]}
          cableApp={cableApp}
          component={ProfilePage}
          exact
          path="/profile"
        />
        <PublicRoute
          cableApp={cableApp}
          component={NewOrganizationPage}
          exact
          path="/organizations/new"
        />
        <PublicRoute
          cableApp={cableApp}
          component={ConfirmEmailPageLock}
          exact
          path="/confirm-email"
        />
        <Route component={PageNotFound} />
      </Switch>
    </Router>
  );
};

ConsumerRoutes.propTypes = {
  cableApp: PropTypes.object.isRequired,
};

export default ConsumerRoutes;
